module.exports = __webpack_public_path__ + "img/header-mobile.8ad42a81.png";